/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import './FailedTransaction.css';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { useCallback, useMemo, useState } from 'react'
import WordCloud from 'react-wordcloud';
import { SelectDropDown, TableSubHeader, useAppDispatch, useAppSelector, useEffectOnce } from '../../globalUtils/globalExports';
import { getCurrentFiltersValues, getCurrentScreenAppliedFiltersCount, getDashboardReducer, getFilterSelectedValue, getReferenceDataReducer, setFilterData, setRedirectedStateForChargingHistoryFilters } from '../../rmsReduxStore/reduxExports';
import { IconWithTooltip } from '../../globalUtils/globalIcons';
import { formatNumberWithCommas, renderHeaderActionButtons } from '../../globalUtils/globalHooks';
import { RectangularSkeleton } from '../../globalUtils/SkeletonDesign/SkeletonDesign';
import CustomFilterLayout, { CustomFilterProp } from './CustomFilterLayout';
import { useNavigate } from 'react-router-dom';


interface FailedTransactionProp {
    handleFilter: Function,
    getFilterValue: Function
}

const FailedTransaction: React.FC<FailedTransactionProp> = (props) => {
    const { handleFilter, getFilterValue } = props;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { intervalRangeReferenceData,chargingStationReferenceData,chargerVisibleIdReferenceData  } = useAppSelector(getReferenceDataReducer);
    const { newDashboardFailedTransactionList, newDashboardFailedTransactionTopReasons } = useAppSelector(getDashboardReducer);
    
    // const [filterValue, setFilterValue] = useState<IGeneralReferenceData>()
    const navigationUpperLimit = 31
    const [visibleMin, setVisibleMin] = useState(0);
    const [visibleMax, setVisibleMax] = useState(navigationUpperLimit);

    const dataLength = newDashboardFailedTransactionList?.length || 0;

    const wordCloudHeight = 140;
    const chartHeight = 320;
    const [filterAnchorEl,setFilterAnchorEl] = useState<HTMLElement  | null>(null);

    // const getFormattedData = useCallback(() => {
    //     const data = newDashboardFailedTransactionList || [];
    //     const xAxis = data.map(item => item.date);
    //     const yAxis = data.map(item => item.session_count);

    //     return { xAxis, yAxis };
    // }, [newDashboardFailedTransactionList]);

    const handleNavigation = (direction: 'left' | 'right') => {
      const step = navigationUpperLimit + 1;
        if (direction === 'left') {
            setVisibleMin(Math.max(visibleMin - step, 0));
            setVisibleMax(Math.max(visibleMax - step, step));
        } else {
            setVisibleMin(Math.min(visibleMin + step, dataLength - (step + 1)));
            setVisibleMax(Math.min(visibleMax + step, dataLength - 1));
        }
    };

    // useEffectOnce(() => {
    //     setFilterValue(getFilterValue('failedTransactionRange'))
    // })
    

    // const handleSelectChange = (val): void => {
    //     const cardValue = val?.label === 'All' ? 'TOTAL' : val?.value?.toString()?.toLocaleUpperCase()
    //     setFilterValue(val);
    //     handleAlarmFilter(val);
    //     handleChartPageReset();
    // };

    const handleChartPageReset = () => {
      setVisibleMin(0);
      setVisibleMax(navigationUpperLimit);
    }

    const handleAlarmFilter = useCallback(async (val): Promise<void> => {
        const res = await setFilterData(val, 'failedTransactionRange', 'dashboardV2', 'SET', false)(dispatch)
        if (res?.message === 'Action dispatched successfully') {
            handleFilter(res?.filters);
        }
    }, [setFilterData])

    const reasonsList = useMemo(() => {
        return newDashboardFailedTransactionTopReasons?.map((reason) => {
            return {
                text: reason?.stop_reason,
                value: reason?.count
            }
        }) || []
    }, [newDashboardFailedTransactionTopReasons])
    
    const options = {
        rotations: 2,
        rotationAngles: [0, 0] as [number, number],
        fontSizes: [15, 30] as [number, number],
        fontFamily: 'sans-serif',
        enableTooltip: false,
        height: wordCloudHeight
    };

    const xAxisLabelFormatter = function (this: Highcharts.AxisLabelsFormatterContextObject) {
      const rawValue = this.value;
      const label = typeof rawValue === 'string' ? rawValue : String(rawValue ?? '');
      const [day, month] = label.split(' ');
    
      const chartWidth = this.axis.chart.chartWidth;
      const numCategories = this.axis.categories?.length || 1;
      const approxCategoryWidth = chartWidth / numCategories;
    
      const shouldWrap = approxCategoryWidth > 0; // adjust threshold if needed
      // const shouldWrap = true
    
      return shouldWrap
        ? `<div style="text-align: center;">${day}<br>${month}</div>`
        : `<div style="text-align: center;">${day}<br><span style="opacity: 0.6; font-size: 10px;">${month}</span></div>`;
    }; 

    const getFormattedData = useCallback(() => {
        const data = newDashboardFailedTransactionList;
        const xAxis = data?.map(item => item?.date) || [];
        const yAxis = data?.map(item => {
          return {
            y:parseFloat(item?.session_count),
            failedPercent:item?.percent?.toFixed(2),
            totalCount: item?.total_session_count
          }
        }) || [];
        return { xAxis, yAxis};
    }, [newDashboardFailedTransactionList]);

    getFormattedData();

    Highcharts.setOptions({
      lang: {
        thousandsSep: ','
      }
    });

    let labelStep = 1;  //draft
    const { xAxis } = getFormattedData();
    const totalBars = xAxis.length;
    if(totalBars > 25) labelStep = 4;
    else if (totalBars > 20) labelStep = 3;
    else if (totalBars > 10) labelStep = 2;

    const chartOptions = {
        chart: {
          type: 'column',
          animation: false,
          height: chartHeight,
          spacingRight: 15,
          events: {
            render: function () {
              const chart = this as Highcharts.Chart & any;
      
              // Remove existing custom arrows before adding new ones
              const existingArrows = chart.container.getElementsByClassName('custom-arrow');
              while (existingArrows.length > 0) {
                existingArrows[0].remove();
              }
      
              // Left arrow (shifted more inside by changing left position)
              if (visibleMin > 0) {
                chart.renderer.image(
                  '/images/left_arrow_highchart.svg',
                  chart.plotLeft - 10, // shifted inside
                  chart.plotTop + chart.plotHeight / 2 - 10,
                  20,
                  20
                )
                .addClass('custom-arrow left')
                .on('click', () => handleNavigation('left'))
                .add();
              }
      
              // Right arrow (shifted more inside by changing left position)
              if (visibleMax < dataLength - 1) {
                chart.renderer.image(
                  '/images/right_arrow_highchart.svg',
                  chart.plotLeft + chart.plotWidth - 10, // shifted inside
                  chart.plotTop + chart.plotHeight / 2 - 10,
                  20,
                  20
                )
                .addClass('custom-arrow right')
                .on('click', () => handleNavigation('right'))
                .add();
              }
            }
          }
        },
        title: { text: '' },
        exporting: { enabled: false },
        credits: { enabled: false },
        xAxis: {
          categories: getFormattedData().xAxis,
          // tickInterval: 1,
          // min: visibleMin,
          // max: visibleMax,
          gridLineWidth: (newDashboardFailedTransactionList?.length ?? 0) > 10 ? 0 : 1,
          gridLineDashStyle: 'ShortDash', 
          lineColor: '#005EFF',
          tickColor: '#005EFF',
          plotBands: getFormattedData().xAxis.map((_, index) => {
            const barWidthFraction = 0.25;
            return {
              from: index - barWidthFraction,
              to: index + barWidthFraction,
              color: '#f5f5f5'
            };
          }),          
          labels: {
            step: labelStep,  //draft
            rotation: 0,
            useHTML: true,
            formatter: xAxisLabelFormatter,
            // style: {
            //   fontSize: '14px'
            // }
          }
        },
        yAxis: {
          min: 0,
          gridLineDashStyle: 'ShortDash',
          title: {
            text: 'No. of Failed Transactions',
            style: {
              fontSize: '14px'
            }
          }
        },
        tooltip: {
        formatter: function (this: Highcharts.Point) {
            const point = formatNumberWithCommas(this.y || 0);
            const percent = formatNumberWithCommas((this as any).point.failedPercent  || 0);
            const total = formatNumberWithCommas((this as any).point.totalCount || 0);
            return `${this.x}<br/><span style="color:${this.color}">\u25CF</span> Failed Transactions: <b>${point} (${percent}%)</b>
            <br/><span style="color:${this.color}">\u25CF</span> Total Transactions: <b>${total}</b>`;
          }
        },
        legend: { enabled: false },
        series: [{
          name: 'Failed Transactions',
          data: getFormattedData().yAxis,
          color: '#00bcbc',
            dataLabels: {
            // enabled: labelStep === 1,
            enabled: false,
            style: {
              fontSize: '12px',
              fontWeight: 'bold'
            }
          }
        }],
        plotOptions: {
          column: {
            borderRadius: 8,
            dataLabels: {
              enabled: true,
              inside: false,
              crop: false,
              overflow: 'none',
              // color: '#000',
              // verticalAlign: 'top',
              // align: 'center',
              style: {
                fontSize: '8px',
                textOutline: 'none',
                fontWeight: '300'
              }
            }
          }
        }
      }  

    const headerActionBtns = renderHeaderActionButtons({
        actionBtns:
            [
                {
                    id: 'add_filter_btn',
                    isAccessible: true,
                    headerActionBtnClick: (e): void => {
                        setFilterAnchorEl(e.currentTarget)
                    },
                    badgeCount: getCurrentScreenAppliedFiltersCount('failedTransaction',true)
                },
            ],
      })

    const handleFilterDataChange = async (val, filterKey, isGlobal) => {
          const res = await setFilterData(val, filterKey, 'failedTransaction', 'SET', isGlobal ? isGlobal : false,true)(dispatch)
          const dashboardV2Filters = getCurrentFiltersValues('dashboardV2')
          
          if (res?.message === 'Action dispatched successfully') {
            handleFilter(dashboardV2Filters,res?.filters)
            handleChartPageReset();
          }
      }

    const failedTransactionsFilterProps: CustomFilterProp[] = useMemo(()=>{
        return [
          {
            filterLabel: 'Charging Stations',
            filterType: 'dropdown',
            filterId: 'chargingStationId',
            filterDropdownProps: {
              selectValue: getFilterSelectedValue('chargingStationId', 'failedTransaction', false),
              selectOptions: chargingStationReferenceData ?? [],
              handleSelectOptionChange: (val): void => {
                handleFilterDataChange(val, 'chargingStationId', false)
              },
              selectDropDownId: 'failed-transaction-chargingStationId-type-filter-dropdown',
              isMultiSelect: true,
              renderToBody:true,
            }
          },
          {
            filterLabel: 'Chargers',
            filterId: 'chargerId',
            filterType: 'dropdown',
            filterDropdownProps: {
              selectValue: getFilterSelectedValue('chargerId', 'failedTransaction', false),
              selectOptions: chargerVisibleIdReferenceData ?? [],
              handleSelectOptionChange: (val): void => {
                handleFilterDataChange(val, 'chargerId', false)
              },
              selectDropDownId: 'failed-transaction-charger-id-filter-dropdown',
              isMultiSelect: true,
              renderToBody: true
            }
          },
          {
            filterLabel: 'Date Range',
            filterId: 'failedTransactionRange',
            filterType: 'dropdown',
            filterDropdownProps: {
              selectValue: getFilterSelectedValue('failedTransactionRange', 'failedTransaction', false),
              selectOptions: intervalRangeReferenceData ?? [],
              handleSelectOptionChange: (val): void => {
                handleFilterDataChange(val, 'failedTransactionRange', false)
              },
              selectDropDownId: 'failed-transaction-date-range-filter-dropdown',
              isMultiSelect: false,
              renderToBody: true
            }
          },
        ]
      },[intervalRangeReferenceData,chargerVisibleIdReferenceData,chargingStationReferenceData,handleFilterDataChange,getFilterSelectedValue])


    const wordCloudCallbacks = {
      onWordClick: async (word: any, event?: MouseEvent) => {
        await setFilterData(null,'','chargingHistoryReport','CLEAR',false)(dispatch);
        setRedirectedStateForChargingHistoryFilters(true,word?.text)(dispatch).then(res => {
          if (res === 'Action dispatched successfully') {
            navigate('/chargingHistory');
          }
        });
      },
    }
    
    return (
        <div className='widget-wrap failed-transaction-wrap'>
            <div className="widget-header failed-transaction-container-header">
                    <div className='failed-transaction-container-heading-sub-heading'>
                        <div className='failed-transaction-container-heading-container'>
                            <div className='widget-heading  failed-transaction-container-heading'>
                                Failed Transaction Analysis
                                <IconWithTooltip iconClassName="info-icon" toolTipText={'Failed session trend and most common reasons'} containerClassName={'new-dashboard-widget-header-tooltip'} />
                            </div>
                        </div>
                        {/* <div className='failed-transaction-container-sub-heading'>
                            Failed session trend and most common reasons
                        </div> */}
                    </div>
                    <div className="failed-transaction-filters">
                        {/* <SelectDropDown
                            selectValue={filterValue}
                            selectOptions={intervalRangeReferenceData ?? []}
                            handleSelectOptionChange={handleSelectChange}
                            selectDropDownId='alarm-failed-transaction-dropdown'
                            dropDownClassName='alarm-failed-transaction-dropdown'
                            isMultiSelect={false}
                            placeholder={'Interval'}
                        /> */}
                        <TableSubHeader headerActionBtns={headerActionBtns}/>
                        <CustomFilterLayout filters={failedTransactionsFilterProps} requiredReferenceDataCallbacks={['chargerVisibleId','chargingStationId']} filterAnchorEl={filterAnchorEl} setFilterAnchorEl={setFilterAnchorEl} excludeGlobalFilters={true} />
                    </div>
                </div>
            <div className='widget-body failed-transactions-body'>
              {
                newDashboardFailedTransactionTopReasons?.length == 0 && newDashboardFailedTransactionList?.length == 0 ?
                  <div className='no-data-text' style={{ height: '450px' }}>
                    No data available
                  </div>
                  :
                  <>
                <div className='failed-transaction-reasons-wrap'>
                    {/* <div className='failed-transaction-reasons-header'>
                        Top 10 Reasons for Transaction Failure
                    </div> */}
                   {!newDashboardFailedTransactionTopReasons ? (
                      <div style={{height: `${wordCloudHeight}px` }}>
                      <RectangularSkeleton skeletonContainerClassName='' />
                      </div>
                  ) : newDashboardFailedTransactionTopReasons?.length === 0 ? (
                    <div className='no-data-text' style={{height: `${wordCloudHeight}px` }}>
                    No reasons found
                  </div>
                  ) :
                  (
                  // <WordCloud words={reasonsList} options={options} />
                  <div
                  className='word-cloud-container'
                  style={{ height: `${wordCloudHeight}px`, overflow: 'hidden' }}
                >
                  <WordCloud words={reasonsList} options={options} callbacks={wordCloudCallbacks} />
                </div>
                  )}
                </div>
                <div className='failed-transaction-chart-wrap'>
                {!newDashboardFailedTransactionList ? (
                  <div style={{ height: `${chartHeight}px` }}>
                    <RectangularSkeleton skeletonContainerClassName='' />
                  </div>
                ) : newDashboardFailedTransactionList?.length === 0 ? (
                  <div className='no-data-text' style={{ height: `${chartHeight}px` }}>
                    No data available
                  </div>
                ) : (
                  <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                )}

                </div>
                </>
              }
            </div>
        </div>
    )
}

export default FailedTransaction